import {
  Container,
  DesignSystemProvider,
  LoadingOverlay,
} from '@hover/blueprint';
import React, { useEffect } from 'react';
import { generatePath, useHistory, useLocation } from 'react-router';

import { useViewSampleImageEmbed } from 'src/modules/homeownerApp/components/Embed/hooks/useViewSampleImageEmbed';
import type { AiDisplayImage } from 'src/modules/homeownerApp/graphql/generated';
import { useActiveOriginalImage } from 'src/modules/homeownerApp/hooks';
import { HomeownerAppProvider } from 'src/modules/homeownerApp/providers';
import { MY_UPLOAD_STYLE } from 'src/modules/homeownerApp/static_values';
import { isSample } from 'src/modules/homeownerApp/types';
import { useGlobalStorageContext } from 'src/shared/hooks/useGlobalStorage';
import { Route } from 'src/shared/route';

export const EmbedContainer = () => {
  const { isLoading: viewSampleImageEmbedLoading, canViewSampleImageEmbed } =
    useViewSampleImageEmbed();
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const originalImageId = queryParams.get('originalImageId') || undefined;

  const publicIdentifier = queryParams.get('aff_org_id') || undefined;
  const { setAffOrgPublicId } = useGlobalStorageContext();

  useEffect(() => {
    if (publicIdentifier) setAffOrgPublicId(publicIdentifier);
  }, [publicIdentifier, setAffOrgPublicId]);

  const { image, loading: originalImageLoading } = useActiveOriginalImage({
    originalImageId,
  });

  const isSampleImage = isSample(image);

  const aiDisplayImageId = isSampleImage
    ? undefined
    : image?.aiDisplayImages?.filter(
        (aiDisplayImage: AiDisplayImage) =>
          aiDisplayImage.style?.toLowerCase() === MY_UPLOAD_STYLE.toLowerCase(),
      )[0].id;

  useEffect(() => {
    if (aiDisplayImageId) {
      history.push({
        pathname: generatePath(Route.HOMEOWNER_APP_CUSTOMIZE_INSPIRE.path, {
          aiDisplayImageId,
        }),
      });
    }
  }, [aiDisplayImageId, history]);

  if (viewSampleImageEmbedLoading || originalImageLoading) {
    return <LoadingOverlay color="neutral.900" isLoading />;
  }

  // TODO: Add the landing page content here and remove the auto redirect to the "inspire" route
  return canViewSampleImageEmbed ? (
    <HomeownerAppProvider>
      <DesignSystemProvider>
        <Container
          display="flex"
          flexDirection="column"
          height="100vh"
          justifyContent="space-between"
        >
          {/* <EmbedLandingPage /> */}
        </Container>
      </DesignSystemProvider>
    </HomeownerAppProvider>
  ) : null;
};
